<template>
  <div
    :class="{
      wrapper: !this.lock,
      container: true,
      'justify-content-center': true,
    }"
  >
    <ClientLayout v-if="user" :user="user"></ClientLayout>

    <!-- Lock Message -->
    <div v-if="this.lock" class="row justify-content-center mt-5">
      <div class="alert alert-danger text-center" role="alert">
        Your account has been suspended due to failed charges on your card.
        Please update with correct billing information.
      </div>
    </div>

    <!-- Main Content -->
    <div class="flex min-h-screen items-start justify-center py-12 px-4">
      <div
        class="grid grid-cols-1 md:grid-cols-12 gap-8 w-full max-w-7xl mx-auto"
      >
        <!-- Checkout Section -->
        <div class="md:col-span-7">
          <Checkout
            :billingInfo="this.billingInfo"
            :isMobile="this.isMobile"
            :payPeriod="this.getPeriod"
            :type="this.subscription.subscriptionName"
            :user="this.user"
            :subscriptionName="this.subscription.subscriptionName"
            :period="this.getPeriod"
            :yearly="this.payYearly"
            :price="this.getPrice"
            :lock="this.lock"
            @proceed="submitPayment()"
          ></Checkout>
        </div>

        <!-- Order Summary Section -->
        <div class="md:col-span-5">
          <div class="sticky top-8 mt-24">
            <OrderSummary
              :subscriptionName="this.subscription.subscriptionName"
              :period="this.getPeriod"
              :price="this.getPrice"
              :monthlyPrice="this.getMonthlyPrice"
              :isMobile="this.isMobile"
              :billingInfo="this.billingInfo"
              :lock="this.lock"
              @back="back()"
              @proceed="submitPayment()"
              @changeBillingPeriod="changeBillingPeriod()"
            ></OrderSummary>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Checkout from '../../components/Subscriptions/Checkout.vue'
import OrderSummary from '../../components/Subscriptions/OrderSummary.vue'
import axios from 'axios'
import swal from 'sweetalert'
import ClientLayout from '../../components/ClientLayout.vue'

export default {
  components: {
    Checkout,
    ClientLayout,
    OrderSummary,
  },
  data() {
    return {
      user: {},
      subscription: {},
      lock: false,
      billingInfo: {
        cardFirstName: '',
        cardLastName: '',
        firstName: '',
        lastName: '',
        cardNumber: '',
        cardMonth: '',
        cardYear: '',
        cardCvv: '',
        phoneNumber: '',
        email: '',
        address: '',
        city: '',
        state: '',
        zipCode: '',
      },
      showCheckout: true,
      showOrderSummary: false,
      subscriptionName: 'Hall of Fame',
      payYearly: true,
      coachFirstName: '',
      coachLastName: '',
      coachEmail: '',
      coachPhoneNumber: '',
      coachAddress: '',
    }
  },
  methods: {
    getSubscription() {
      let url =
        import.meta.env.VITE_APP_DB_URL +
        'subscription/getSubscription?id=' +
        this.$route.params.id
      axios
        .get(url, {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
          },
        })
        .then(response => {
          this.subscription = response.data.subscription
          console.log(response.data.subscription)
        })
    },
    changeBillingPeriod() {
      this.payYearly = !this.payYearly
      this.$route.params.payYearly = this.payYearly
    },
    proceedToOrderSummary() {
      this.showCheckout = false
      this.showOrderSummary = true
    },
    back() {
      this.showCheckout = true
      this.showOrderSummary = false
    },
    submitPayment() {
      swal({
        title: 'Wait for confirmation',
        text: 'Please wait for confirmation',
        icon: 'warning',
        buttons: false,
      })
      let oldSubscriptionID = null
      if (this.user) {
        if (this.user.subscription) {
          oldSubscriptionID = this.user.subscription.subscriptionID
        }
      }
      this.billingInfo.firstName = this.billingInfo.cardFirstName
      this.billingInfo.lastName = this.billingInfo.cardLastName
      if (!this.user) {
        this.billingInfo.email = this.$route.query.email
        this.billingInfo.phoneNumber = this.$route.query.phoneNumber
        this.billingInfo.address = this.$route.query.address
      }
      let url = import.meta.env.VITE_APP_DB_URL + 'user/subscriptionPurchase'
      axios
        .post(
          url,
          {
            period: this.getPeriod,
            price: this.getPrice,
            billingInfo: this.billingInfo,
            id: this.$route.params.id,
          },
          {
            headers: {
              Authorization: 'Bearer ' + localStorage.getItem('jwt'),
            },
          },
        )
        .then(response => {
          swal('Success', 'Purchase Successful', 'success')
          let token = response.data.token
          let tempUser = response.data.user
          let user = {
            _id: tempUser._id,
            email: tempUser.email,
            firstName: tempUser.firstName,
            lastName: tempUser.lastName,
            subscription: tempUser.subscription,
            phoneNumber: tempUser.phoneNumber,
            address: tempUser.address,
            city: tempUser.city,
            state: tempUser.state,
            zipCode: tempUser.zipCode,
            accountActive: tempUser.accountActive,
          }
          localStorage.setItem('jwt', token)
          localStorage.setItem('user', JSON.stringify(user))
          localStorage.setItem('advertisementShown', 'false')
          if (token) {
            swal('Success', 'Purchase Successful', 'success')
            this.$router.push('/Dashboard')
          }
        })
        .catch(() => {
          swal(
            'Purchase Failed',
            'Please check your billing information and try again',
            'error',
          )
        })
      if (oldSubscriptionID) {
        let url =
          import.meta.env.VITE_APP_DB_URL + 'subscription/cancelSubscription'
        axios.post(
          url,
          {
            subscriptionID: oldSubscriptionID,
          },
          {
            headers: {
              Authorization: 'Bearer ' + localStorage.getItem('jwt'),
            },
          },
        )
      }
    },
  },
  created() {
    this.getSubscription()
    if (this.$route.params.payYearly === 'true') {
      this.payYearly = !!this.$route.params.payYearly
    } else {
      this.payYearly = false
    }

    this.user = JSON.parse(localStorage.getItem('user'))
    if (this.user) {
      this.showCheckout = true
    }
  },
  computed: {
    isMobile: function () {
      var check = false
      ;(function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a,
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(
            a.substr(0, 4),
          )
        )
          check = true
      })(navigator.userAgent || navigator.vendor || window.opera)
      return check
    },
    getPeriod() {
      if (this.payYearly) {
        return 'Year'
      } else {
        return 'Month'
      }
    },
    getPrice() {
      let price
      if (this.payYearly) {
        price = this.subscription.yearlyPrice
      } else {
        price = this.subscription.monthlyPrice
      }
      return price
    },
    getMonthlyPrice() {
      return this.subscription.monthlyPrice
    },
  },
  mounted() {
    if (this.$route.query.lock) {
      this.lock = true
    }
  },
}
</script>
<style scoped>
.navigation {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 80px;
  background-color: white;
  border-bottom: 1px solid rgba(38, 38, 38, 0.1);
  z-index: 30;
}

.navigation .container {
  max-width: unset;
  height: 100%;
  padding: 0 40px;
  display: flex;
  align-items: center;
}

.sa-header {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  gap: 16px;
}

.sa-logo {
  border-radius: 20%;
}

.sa-header .sa-logo-wrapper {
  width: 90px;
  display: flex;
}

.sa-nav-wrapper {
  flex: 1;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 54px;
}

.sa-nav-wrapper .sa-menu {
  height: 100%;
  display: flex;
  gap: 40px;
}

.sa-menu .sa-menu-item {
  height: 100%;
  display: flex;
  align-items: center;
  color: black;
  font-size: 16px;
  font-weight: 500;
  line-height: 26px;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.sa-menu .sa-menu-item:hover,
.sa-menu .sa-menu-item.active {
  color: #363166;
}

.sa-menu .sa-menu-item::after {
  content: '';
  width: 100%;
  height: 3px;
  background-color: #363166;
  position: absolute;
  bottom: 0;
  left: -100%;
  transition: all 0.3s ease;
}

.sa-menu .sa-menu-item:hover::after,
.sa-menu .sa-menu-item.active::after {
  left: 0;
}

.sa-menu-btns-wrapper {
  display: flex;
  align-items: center;
  gap: 16px;
}

.sa-image {
  width: 100%;
  height: 100%;
  display: block;
}

.sa-image-cover {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.sa-image-cover.fit-pos-top {
  object-position: top;
}

.sa-image-contained {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
}
</style>
